import { createLogger } from '@/logger';

import {
  userPool,
  userAttributesFromHash,
} from './cognito';

const log = createLogger('auth.signup');

function guid(a) {
  return a ?
    //eslint-disable-next-line
    (a ^ Math.random() * 16 >> a / 4).toString(16) :
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, guid);
}

function errorToFriendlyMessage(err, email) {
  if (err.code === 'AliasExistsException') {
    log.warning({
      message: `Signup attempt with existing email: "${email}".`,
    });

    return 'There is already an account with the email you provided, ' +
      'perhaps you\'d like to reset your password?';
  }

  if (err.code === 'CodeMismatchException') {
    return 'Sorry, that code was invalid. Please try again.';
  }

  log.error({
    message: `Encountered unmatched error during signup with email: "${email}"`,
    exception: err,
  });

  return err.message;
}

function callback(email, error, success) {
  return (err, res) =>
    (err ? error(errorToFriendlyMessage(err, email)) : success(res));
}

export default function signup({
  email, password, given_name, family_name, consent_date,
  success, error, verificationRequired,
}) {
  const awsAttrs = userAttributesFromHash({
    email,
    given_name,
    family_name,
    'custom:consent_date': consent_date,
  });

  const cb = callback(email, error, (res) => {
    const user = res.user;

    log.information({
      message: `User account "${email}" pending verification.`,
    });

    verificationRequired(({ code }) => {
      user.confirmRegistration(code, false, callback(email, error, () => {
        log.information({
          message: `User account "${email}" successfully verified.`,
        });

        success();
      }));
    });
  });

  userPool.signUp(guid(), password, awsAttrs, null, cb);
}



// WEBPACK FOOTER //
// ./src/auth/signup.js